import flameIcon from '/business/shared/images/icons/bp-icon-flame-bp-green.svg';
import targetIcon from '/business/shared/images/icons/bp-icon-target-bp-green.svg';
import documentIcon from '/business/shared/images/icons/bp-icon-document-plus-bp-green.svg';
import policyIcon from '/business/shared/images/icons/bp-icon-tick-policy-bp-green.svg';
import infoIcon from '/business/shared/images/icons/bp-icon-info-bold-bp-green.svg';

export type ReduceNavItem = {
  icon: string;
  key: 'comparison' | 'hotspots' | 'targets' | 'initiatives' | 'request' | 'plan';
  url: 'comparison' | 'hotspots' | 'targets' | 'initiatives' | 'request-information' | 'plan';
};

const nav: ReduceNavItem[] = [
  {
    key: 'comparison',
    url: 'comparison',
    icon: infoIcon,
  },
  {
    key: 'hotspots',
    url: 'hotspots',
    icon: flameIcon,
  },
  {
    key: 'targets',
    url: 'targets',
    icon: targetIcon,
  },
  {
    key: 'initiatives',
    url: 'initiatives',
    icon: documentIcon,
  },
  {
    key: 'request',
    url: 'request-information',
    icon: infoIcon,
  },
  {
    key: 'plan',
    url: 'plan',
    icon: policyIcon,
  },
];
export default nav;
